import React, { useMemo, useState } from "react";
import { Button, Col, Form, Input, Label, Row } from "reactstrap";
import ToastAlert from "../../Components/Common/ToastAlert";
import { APIClient } from "../../helpers/api_helper";

const AddLocationModal = ({ isOpen, toggle, existingKeywords, getInputList }) => {
    const api = useMemo(() => new APIClient(), []);

    const [location, setLocation] = useState("");
    const [country, setCountry] = useState("TR");
    const [selectedKeywords, setSelectedKeywords] = useState([]);

    const allSelected = existingKeywords.length > 0 && selectedKeywords.length === existingKeywords.length;

    const toggleAll = () => {
        if (allSelected) {
            setSelectedKeywords([]);
        } else {
            setSelectedKeywords(existingKeywords.map(k => k.keyword));
        }
    };

    const toggleKeyword = (keyword) => {
        setSelectedKeywords(prev =>
            prev.includes(keyword) ? prev.filter(k => k !== keyword) : [...prev, keyword]
        );
    };

    const handleModalClick = (e) => {
        if (e.target.classList.contains("modal")) {
            toggle();
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!location.trim()) {
            ToastAlert("Location cannot be empty.", "warning");
            return;
        }
        if (selectedKeywords.length === 0) {
            ToastAlert("Please select at least one keyword.", "warning");
            return;
        }
        try {
            await Promise.all(
                selectedKeywords.map(keyword =>
                    api.update("v1/inputs/", { location: location.trim(), keyword, country: country.toUpperCase() })
                )
            );
            await getInputList();
            toggle();
            ToastAlert(`${selectedKeywords.length} combination(s) added successfully.`, "success");
        } catch (error) {
            ToastAlert(error, "error");
        }
    };

    return (
        <React.Fragment>
            <div
                className={`modal fade ${isOpen ? "show" : ""}`}
                tabIndex="-1"
                role="dialog"
                style={{ display: isOpen ? "block" : "none" }}
                onClick={handleModalClick}
            >
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header border-bottom-0">
                            <h5 className="modal-title">Add Location</h5>
                            <button type="button" className="btn-close" onClick={toggle}></button>
                        </div>
                        <div className="modal-body">
                            <Form onSubmit={handleSubmit}>
                                <Row className="mb-3">
                                    <Col md={8}>
                                        <Label className="form-label">
                                            Location <span className="text-danger">(*)</span>
                                        </Label>
                                        <Input
                                            type="text"
                                            autoFocus
                                            className="form-control"
                                            value={location}
                                            onChange={e => setLocation(e.target.value)}
                                            placeholder="e.g. Istanbul"
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <Label className="form-label">
                                            Country Code <span className="text-danger">(*)</span>
                                        </Label>
                                        <Input
                                            type="text"
                                            className="form-control"
                                            value={country}
                                            onChange={e => setCountry(e.target.value.toUpperCase())}
                                            placeholder="TR"
                                            maxLength={2}
                                        />
                                    </Col>
                                </Row>

                                <div className="mb-3">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <Label className="form-label mb-0">
                                            Match with Keywords <span className="text-danger">(*)</span>
                                        </Label>
                                        {existingKeywords.length > 0 && (
                                            <Button type="button" size="sm" color="secondary" outline onClick={toggleAll}>
                                                {allSelected ? "Deselect All" : "Select All"}
                                            </Button>
                                        )}
                                    </div>
                                    {existingKeywords.length === 0 ? (
                                        <p className="text-muted small">No keywords yet.</p>
                                    ) : (
                                        <div className="border rounded p-2" style={{ maxHeight: "220px", overflowY: "auto" }}>
                                            {existingKeywords.map(k => (
                                                <div key={k.keyword} className="form-check mb-1">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`loc-kw-${k.keyword}`}
                                                        checked={selectedKeywords.includes(k.keyword)}
                                                        onChange={() => toggleKeyword(k.keyword)}
                                                    />
                                                    <label className="form-check-label" htmlFor={`loc-kw-${k.keyword}`}>
                                                        {k.keyword}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                <div className="hstack gap-2 justify-content-end">
                                    <Button type="button" className="btn btn-light" onClick={toggle}>
                                        Cancel
                                    </Button>
                                    <Button type="submit" className="btn btn-success">
                                        Save
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
            {isOpen && <div className="modal-backdrop fade show"></div>}
        </React.Fragment>
    );
};

export default AddLocationModal;
